import { useCallback, useSyncExternalStore } from "react";

const CLAVE = "fc-tema";

/** Lee el tema del atributo `data-theme` del documento, no de una copia en memoria. */
function leer(): "light" | "dark" {
  return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
}

function suscribir(cambio: () => void): () => void {
  const observador = new MutationObserver(cambio);
  observador.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"],
  });
  return () => observador.disconnect();
}

/**
 * El tema: claro por defecto, el oscuro se elige y se recuerda. No se hereda del
 * sistema operativo a propósito — que el equipo tenga Windows en oscuro no dice
 * nada sobre lo que quiere quien atiende el mostrador. El sistema de diseño lee
 * `data-theme` para forzar; aquí lo forzamos siempre.
 */
export function useTheme() {
  const modo = useSyncExternalStore(suscribir, leer, () => "light" as const);

  const alternar = useCallback(() => {
    const nuevo = leer() === "dark" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", nuevo);
    try {
      localStorage.setItem(CLAVE, nuevo);
    } catch {
      /* sin almacenamiento: el cambio vale para esta sesión */
    }
  }, []);

  return { modo, alternar };
}
